import api from './client';

export const getVehicles = (params) => api.get('/vehicles', { params }).then(r => r.data);
export const getVehicle = (id) => api.get(`/vehicles/${id}`).then(r => r.data);
export const createVehicle = (data) => api.post('/vehicles', data).then(r => r.data);
export const updateVehicle = (id, data) => api.put(`/vehicles/${id}`, data).then(r => r.data);
export const deleteVehicle = (id) => api.delete(`/vehicles/${id}`).then(r => r.data);
export const assignVehicle = (id, userId) => api.post(`/vehicles/${id}/assign`, { user_id: userId }).then(r => r.data);

export const getVehicleLogs = (id) => api.get(`/vehicles/${id}/logs`).then(r => r.data);
export const addFuelLog = (id, data) => api.post(`/vehicles/${id}/logs`, data).then(r => r.data);

export const getFuelPrices = () => api.get('/vehicles/fuel-prices/current').then(r => r.data);
export const saveFuelPrice = (data) => api.post('/vehicles/fuel-prices', data).then(r => r.data);
